import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container, Paper, Typography, TextField, Button, Alert, Box
} from '@mui/material';
import axios from 'axios';

const ResetPassword = () => {
  const { uidb64, token } = useParams();
  const navigate = useNavigate();

  const [validToken, setValidToken] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const apiUrl = process.env.REACT_APP_BASE_URL;
  useEffect(() => {
    const confirmToken = async () => {
      try {
        await axios.get(`${apiUrl}/password-reset-confirm/${uidb64}/${token}/`);
        setValidToken(true);
      } catch (error) {
        setMessage("⛔ This password reset link is invalid or expired.");
        setIsSuccess(false);
      }
    };
    confirmToken();
  }, [uidb64, token]);

  const handleSubmit = async () => {
    if (newPassword !== confirmPassword) {
      setMessage("❗Passwords do not match.");
      setIsSuccess(false);
      return;
    }

    try {
      await axios.post(`${apiUrl}/set-new-password/${uidb64}/${token}/`,
        {
          password: newPassword,
          confirm_password: confirmPassword
        }
      );
      setMessage("✅ Password reset successfully! Redirecting to login...");
      setIsSuccess(true);
      setTimeout(() => navigate('/'), 3000);
    } catch (error) {
      console.error(error);
      setMessage("❌ Failed to reset password. Please try again.");
      setIsSuccess(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to right, #6a11cb, #2575fc)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 5,
          maxWidth: 500,
          width: '100%',
          borderRadius: 4,
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
        }}
      >
        <Typography variant="h4" align="center" fontWeight="bold" gutterBottom>
          🔒 Reset Password
        </Typography>
        <Typography variant="body1" align="center" color="textSecondary" mb={3}>
          Enter and confirm your new password to regain access.
        </Typography>

        {message && (
          <Alert severity={isSuccess ? 'success' : 'error'} sx={{ mb: 3 }}>
            {message}
          </Alert>
        )}

        {validToken ? (
          <>
            <TextField
              fullWidth
              type="password"
              label="New Password"
              variant="outlined"
              margin="normal"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <TextField
              fullWidth
              type="password"
              label="Confirm Password"
              variant="outlined"
              margin="normal"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              sx={{ mt: 3, borderRadius: 2, fontWeight: 'bold' }}
              onClick={handleSubmit}
            >
              Set New Password
            </Button>
          </>
        ) : (
          <Typography variant="body2" align="center" color="text.secondary">
            If this message is incorrect, try requesting a new reset link.
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default ResetPassword;
